// MUI
import { Box, IconButton, Typography } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

// Third party
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

// Hooks
import { useBoolean } from '../../../../hooks';
import { useLoginAPI } from '../../../../hooks/API/welcome';

// Components
import { ResetPasswordDialog, WelcomeActionButton } from './index';
import { FormProvider, RHFTextField, LoginSchema } from '../../../../components/form';

const LoginForm = () => {
  const showPassword = useBoolean();
  const forgotPassword = useBoolean();

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues: {
      identifier: '',
      password: '',
    },
    mode: 'onChange',
  });

  const { handleSubmit, formState } = methods;
  const { isSubmitting } = formState;

  const { mutate: login, isPending: loginLoading } = useLoginAPI();

  const onSubmit = handleSubmit(data => {
    login(data);
  });

  return (
    <>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <RHFTextField fullWidth sx={{ mb: 3 }} name="identifier" placeholder="Username or Email" />

        <RHFTextField
          fullWidth
          placeholder="Password"
          name="password"
          type={showPassword.value ? 'text': 'password'}
          slotProps={{
            input: {
              endAdornment: (
                <IconButton onClick={showPassword.onToggle} edge="start">
                  {showPassword.value ? <VisibilityOff />: <Visibility />}
                </IconButton>
              ),
            },
          }}
        />

        <Typography
          variant="body2"
          sx={{ textAlign: 'right', cursor: 'pointer', color: 'grey', mt: 1 }}
          onClick={forgotPassword.onToggle}
        >
          Forgot Password?
        </Typography>

        <Box sx={{ my: 2.5, mx: 'auto', height: 50 }}>
          <WelcomeActionButton isLoading={loginLoading} isSubmitting={isSubmitting} text="Log in" />
        </Box>
      </FormProvider>

      <ResetPasswordDialog forgotPassword={forgotPassword} />
    </>
  );
};

export { LoginForm };